// src/CatalogGateModal.jsx
// Small lead-capture gate in front of the catalogue PDF: collects name,
// email, phone, company and city, saves it as a lead in Firestore, then
// opens the PDF. Reuses SupportForm.css so the modal matches the site's
// existing support/contact modals instead of introducing a new visual
// style.
import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import { reportConversion } from "./utils/googleAdsConversion";
import "./SupportForm.css";

const CatalogGateModal = ({ pdfUrl, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [city, setCity] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!name || !email || !phone || !city) {
      setError("Please enter your name, email, phone number and city.");
      return;
    }

    setSubmitting(true);
    try {
      await addDoc(collection(db, "catalog_leads"), {
        name,
        email,
        phone,
        company,
        city,
        page: window.location.pathname,
        createdAt: serverTimestamp(),
      });

      reportConversion("catalogueDownload", { email, phone });
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
      onClose();
    } catch (err) {
      console.error("Catalogue lead submission error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="support-modal-overlay" onClick={onClose}>
      <div
        className="support-modal"
        style={{ width: "min(420px, 90%)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="support-form-header">
          <h2>Download Catalog</h2>
          <button className="support-close-btn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <p style={{ marginTop: 0, marginBottom: 18, color: "#4b5563", fontSize: "0.9rem" }}>
          Enter your details to get our full product catalog (PDF).
        </p>

        <form className="support-form" onSubmit={handleSubmit}>
          {error && (
            <div className="support-field full-width" style={{ color: "#b91c1c", fontSize: "0.9rem" }}>
              {error}
            </div>
          )}

          <div className="support-field">
            <label>Name *</label>
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="support-field">
            <label>Email Address *</label>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="support-field">
            <label>Phone Number *</label>
            <input
              type="tel"
              placeholder="Enter your phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          <div className="support-field">
            <label>Company</label>
            <input
              type="text"
              placeholder="Enter your company name"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
          </div>

          <div className="support-field">
            <label>City *</label>
            <input
              type="text"
              placeholder="Enter your city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
          </div>

          <div className="attachment-submit">
            <button type="submit" className="support-submit-btn" disabled={submitting}>
              {submitting ? "Please wait..." : "Get Catalog"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CatalogGateModal;
